import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export default function Footer() {
  const { config } = useStore();
  return (
    <footer data-testid="site-footer" className="bg-[#0C0C0C] text-ivory border-t border-white/10">
      <div className="px-4 sm:px-8 lg:px-16 py-16 lg:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-2 mb-6">
            <span className="w-2 h-2 bg-champagne inline-block" />
            <span className="font-serif text-xl tracking-[0.18em]">THE GOOD GRID</span>
          </div>
          <p className="text-ivory/50 text-sm leading-relaxed max-w-sm">
            A premium corporate gifting partner focused on thoughtful products, trusted brands and effortless bulk gifting.
          </p>
          <p className="text-ivory/30 text-xs font-mono uppercase tracking-[0.2em] mt-8">
            Gifts That Mean Business.
          </p>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-champagne mb-5">Explore</p>
          <ul className="space-y-3 text-sm text-ivory/60">
            <li><Link data-testid="footer-collections" to="/collections" className="hover:text-ivory transition-colors">Collections</Link></li>
            <li><Link data-testid="footer-brands" to="/brands" className="hover:text-ivory transition-colors">Brands</Link></li>
            <li><Link data-testid="footer-custom-gifting" to="/custom-gifting" className="hover:text-ivory transition-colors">Custom Gifting</Link></li>
            <li><Link data-testid="footer-about" to="/about" className="hover:text-ivory transition-colors">About</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-champagne mb-5">Corporate</p>
          <ul className="space-y-3 text-sm text-ivory/60">
            <li><Link data-testid="footer-corporate-gifting" to="/corporate-gifting" className="hover:text-ivory transition-colors">Corporate Gifting</Link></li>
            <li><Link data-testid="footer-request-quote" to="/request-quote" className="hover:text-ivory transition-colors">Request a Quote</Link></li>
            <li><Link data-testid="footer-gifting-list" to="/gifting-list" className="hover:text-ivory transition-colors">My Gifting List</Link></li>
            <li><Link data-testid="footer-contact" to="/contact" className="hover:text-ivory transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-champagne mb-5">Contact</p>
          <ul className="space-y-3 text-sm text-ivory/60">
            <li>
              {config.contact_email ? (
                <a data-testid="footer-email" href={`mailto:${config.contact_email}`} className="hover:text-ivory transition-colors">{config.contact_email}</a>
              ) : (
                <span data-testid="footer-email">Email — available on enquiry</span>
              )}
            </li>
            <li data-testid="footer-phone">{config.contact_phone || "Phone — available on enquiry"}</li>
            <li>
              <Link to="/request-quote" data-testid="footer-cta" className="inline-flex items-center gap-1.5 text-ivory border-b border-champagne/60 pb-0.5 hover:text-champagne transition-colors">
                Start a corporate order <ArrowUpRight size={13} />
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row justify-between gap-3 text-[11px] font-mono uppercase tracking-[0.2em] text-ivory/30">
        <span>© 2026 THE GOOD GRID</span>
        <span>Curated products. Considered gifting.</span>
      </div>
    </footer>
  );
}
